import { useEffect } from "react";
import { useAuth } from "src/context";
import { useNavigate, Outlet } from "react-router-dom";

export default () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const isAuthenticated = !!user && "accessToken" in user;

  useEffect(() => {
    if (isAuthenticated) {
      void navigate("/select-location", { replace: true });
    }
  }, [isAuthenticated]);

  return isAuthenticated ? null : <Outlet />;
};
